import type { PositionalArgs } from 'ember-modifier';
import type AuthorizationService from 'volta/services/authorization';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';

export interface CannotSignature {
  Args: {
    Positional: [string, string];
  };
  Return: boolean;
}

export default class Cannot extends Helper<CannotSignature> {
  @service authorization!: AuthorizationService;

  // eslint-disable-next-line ember/no-observers
  onPermissionsInit = observer('authorization.permissions', () => {
    this.recompute();
  });
  compute([right, entityType]: PositionalArgs<CannotSignature>) {
    return this.authorization.cannot(entityType, right);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    cannot: typeof Cannot;
  }
}
